/* tslint:disable */
/* eslint-disable */
/**
 * UPM-metsa-api
 * UPM Metsä API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Metadata,
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './';

/**
 * 
 * @export
 * @interface GritBatch
 */
export interface GritBatch {
    /**
     * 
     * @type {string}
     * @memberof GritBatch
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GritBatch
     */
    batchNumber: string;
    /**
     * 
     * @type {number}
     * @memberof GritBatch
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof GritBatch
     */
    supplier: string;
    /**
     * 
     * @type {Date}
     * @memberof GritBatch
     */
    deliveryDate: Date;
    /**
     * 
     * @type {Metadata}
     * @memberof GritBatch
     */
    metadata?: Metadata;
}

export function GritBatchFromJSON(json: any): GritBatch {
    return GritBatchFromJSONTyped(json, false);
}

export function GritBatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): GritBatch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'batchNumber': json['batchNumber'],
        'amount': json['amount'],
        'supplier': json['supplier'],
        'deliveryDate': (new Date(json['deliveryDate'])),
        'metadata': !exists(json, 'metadata') ? undefined : MetadataFromJSON(json['metadata']),
    };
}

export function GritBatchToJSON(value?: GritBatch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'batchNumber': value.batchNumber,
        'amount': value.amount,
        'supplier': value.supplier,
        'deliveryDate': (value.deliveryDate.toISOString()),
        'metadata': MetadataToJSON(value.metadata),
    };
}


